<template>
  <v-card
    class="elevation-16 mx-auto video-card"
    width="100%"
    style="height:100%"
  >
    <vidyo
      @disconnect="onVideoCallDisconnect()"
      v-if="widgetData.config.enableVideo && widgetData.config.videoVendor === 'vidyo'"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Vidyo from "../components/Vidyo";
import Utils from "../helpers/utils";

export default {
  name: "VideoView",
  components: {
    vidyo: Vidyo,
  },
  data() {
    return {
      vs: null,
    };
  },
  computed: {
    ...mapGetters([
      "chatData",
      "appData",
      "widgetData",
      "agentTypingStatus",
      "participantName",
      "isConnect",
      "isAgentRespond",
      "videoView",
      "conversationView",
    ]),
  },
  methods: {
    onVideoCallDisconnect() {
      // Utils.log.debug("videoView - onVideoCallDisconnect");
      //if still connect
      // if (
      //   this.$store.state.appData.DataGlobal.connId &&
      //   this.$store.state.appData.DataGlobal.connId !== -1
      // ) {
      //   this.$store.commit("setCurrentView", "chat");
      //   /*Set {} - since we want that renderer will stay on DOM
      //   if we assign "null" so v-if will destruct this view.*/
      //   this.$store.commit("setVideoMessage", {});
      // }
    },
  },
};
</script>

<style scoped>
/* .video-card {
  margin: 10px;
} */
</style>
